import { withInstall } from '@jdesign-vue/utils'
import Drawer from './src/drawer.vue'

export const JdDrawer = withInstall(Drawer)
export default JdDrawer

export * from './src/drawer'
